import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle } from './restrictedInputItem.style';

export class RestrictedInputItem extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Border: {
          type: Lightning.components.BorderComponent,
        },
        Number: { text: { text: '' } },
      },
      getInitialStyle(),
    );
  }

  set borderColor(color) {
    this.tag('Border').colorBorder = color.color;
    this.borderAlpha = color.opacity;
  }

  set borderAlpha(value) {
    this.tag('Border').alpha = value;
  }

  set itemContent(value) {
    if (!value) return;

    this.tag('Number').text.text = value;
  }

  clearItemContent() {
    this.tag('Number').text.text = '';
  }
}
